<script>
import { Bar } from "vue-chartjs";

export default {
  extends: Bar,
  props: {
    dataOrder: Object,
    listDate: Array,
    listSite: Array,
  },
  data: () => ({
    dataSetSite: [],
  }),
  methods: {
    //Site
    loadDataSetSite() {
      var dataTemp = {
        label: "",
        backgroundColor: "",
        data: [],
      };

      var platform = [];

      for (const i in this.dataOrder) {
        for (const j in this.dataOrder[i]) {
          platform.push(j);
        }
        break;
      }

      console.log(platform);

      for (const i of platform) {
        dataTemp.label = i;
        for (const j in this.dataOrder) {
          //console.log("j: ",j)
          for (const k in this.dataOrder[j]) {
            //console.log("k: ",k)
            //console.log(this.dataChart[j][k])
            if (i == k) {
              dataTemp.data.push(this.dataOrder[j][k]);
            }
          }
        }

        if (dataTemp.label == "Shopify") {
          dataTemp.backgroundColor = "#90B945";
        } else if (dataTemp.label == "Amazon") {
          dataTemp.backgroundColor = "#F69400";
        }

        this.dataSetSite.push(dataTemp);
        dataTemp = {
          label: "",
          backgroundColor: "",
          data: [],
        };
      }

      // var dataTotal = {
      //     label: "Total",
      //     backgroundColor: "transparent",
      //     data: []
      // }

      // for(var q = 0; q < this.listDate.length; q++){
      //     var sum = 0
      //     for(var p = 0; p < this.dataSetSite.length; p++){
      //         sum += this.dataSetSite[p].data[q]
      //     }
      //     dataTotal.data.push(sum)
      // }

      // this.dataSetSite.push(dataTotal)
      console.log(this.dataSetSite);
      this.loadChartSite();
    },
    loadChartSite() {
      console.log("loadChartSite");
      this.renderChart(
        {
          labels: this.listDate,
          datasets: this.dataSetSite,
        },
        {
          responsive: true,
          maintainAspectRatio: false,
          legend: { position: "bottom" },
          title: {
            display: true,
            text: "Orders In Last 30 Days",
          },
          tooltips: {
            mode: "index",
            intersect: false,
          },
          scales: {
            xAxes: [
              {
                stacked: true,
              },
            ],
            yAxes: [
              {
                stacked: true,
              },
            ],
          },
        }
      );
    },
  },
  mounted() {
    this.loadDataSetSite();
    // console.log('this.dataSetSite: ',this.dataSetSite)
    // console.log('this.listDate: ',this.listDate)
  },
};
</script>